"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreFeaturesFeatureFlagTestProvider = void 0;
const react_1 = __importDefault(require("react"));
const CoreFeaturesContext_1 = require("./CoreFeaturesContext");
function CoreFeaturesFeatureFlagTestProvider({ ffOverides, isLoadingOverride, children, }) {
    const getFeatureFlagAssignment = (flagKey) => {
        const override = ffOverides?.[flagKey];
        if (override !== undefined) {
            return override;
        }
        return true;
    };
    const isLoading = isLoadingOverride === undefined ? true : isLoadingOverride;
    return (react_1.default.createElement(CoreFeaturesContext_1.CoreFeaturesContext.Provider, { value: {
            isLoading,
            getFeatureFlagAssignment,
            getExperimentAssignment: () => '',
        } }, children));
}
exports.CoreFeaturesFeatureFlagTestProvider = CoreFeaturesFeatureFlagTestProvider;
